const accountLocalization = {
  en: {
    login: 'Login',
    password: 'Password',
    signIn: 'Sign In',
    myIdcAuth: 'Signing in with «My IDC» app',
    myIdcAuth1: '1. Install «My IDC» app on your smartphone.',
    myIdcAuth2: '2. Scan QR-code with camera or scanner and follow the link.',
    myIdcAuth3: '3. «My IDC» app open on available access points',
    myIdcAuth4:
      '4. Select needed access point - login and password filled automatic',
    signInWithApp: 'Sign in with «My IDC»',
  },
  ru: {
    login: 'Логин',
    password: 'Пароль',
    signIn: 'Войти',
    myIdcAuth: 'Авторизация через приложение «Мой IDC»',
    myIdcAuth1: '1. Установите приложение «Мой IDC» на ваш смартфон.',
    myIdcAuth2:
      '2. Отсканируйте QR-код с помощью камеры или любого сканера и перейдите по ссылке.',
    myIdcAuth3:
      '3. Приложение «Мой IDC» автоматически откроется в разделе с доступными точками доступа IPTV.',
    myIdcAuth4:
      '4. Выберите нужную точку доступа - логин и пароль подставятся автоматически',
    signInWithApp: 'Войти через «Мой IDC»',
  },
};

export default accountLocalization;
